import { DocumentNode, gql } from '@apollo/client';
import {
  Divider,
  FormControl,
  FormLabel,
  Stack,
  Switch,
  Text,
  useToast,
} from '@chakra-ui/react';

import { Card } from '@/imports/ui/chakra/components/Card';

import { EventNotifications_User } from './graphql-types/EventNotifications_User';

export const EventNotifications: React.FC<{
  user: EventNotifications_User;
  isDisabled?: boolean;
  onChange: (data: {
    eventConfirmationEmails?: boolean;
    eventReminderEmails?: boolean;
    eventSummaryEmails?: boolean;
    sponsoredEventEmails?: boolean;
  }) => Promise<void>;
}> & {
  userFragment: DocumentNode;
} = ({ user, isDisabled, onChange }) => {

  return (
    <Card overflow="hidden">
      <Stack spacing="0">
        <Text fontSize="sm" p="4" bg="secondary.500" color="textPrimary.500" fontWeight="600">
          Events
        </Text>
        <Divider />
        <Stack spacing="0">
          <Stack px="4" py="4">
          <FormControl
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            w="full"
            isDisabled={isDisabled}
          >
            <FormLabel mb="0" color="textPrimary.500" _disabled={{ color: "textPrimary.500", opacity: 1 }}>Confirmation Emails</FormLabel>
            <Switch
              isChecked={
                user.eventConfirmationEmails === null ||
                user.eventConfirmationEmails === undefined
                  ? true
                  : user.eventConfirmationEmails
              }
              onChange={async ({ target: { checked } }) => {
                await onChange({
                  eventConfirmationEmails: checked,
                });
              }}
            />
          </FormControl>
        </Stack>
        <Divider border="1px solid" borderColor="secondary.500" mt="0" />
        <Stack px="4" py="4">
          <FormControl
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            w="full"
            isDisabled={isDisabled}
          >
            <FormLabel mb="0" color="textPrimary.500" _disabled={{ color: "textPrimary.500", opacity: 1 }}>Event Reminder Emails</FormLabel>
            <Switch
              isChecked={
                user.eventReminderEmails === null ||
                user.eventReminderEmails === undefined
                  ? true
                  : user.eventReminderEmails
              }
              onChange={async ({ target: { checked } }) => {
                await onChange({
                  eventReminderEmails: checked,
                });
              }}
            />
          </FormControl>
        </Stack>
        <Divider border="1px solid" borderColor="secondary.500" mt="0" />
        <Stack px="4" py="4">
          <FormControl
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            w="full"
            isDisabled={isDisabled}
          >
            <FormLabel mb="0" color="textPrimary.500" _disabled={{ color: "textPrimary.500", opacity: 1 }}>Event Summary Emails</FormLabel>
            <Switch
              isChecked={
                user.eventSummaryEmails === null ||
                user.eventSummaryEmails === undefined
                  ? true
                  : user.eventSummaryEmails
              }
              onChange={async ({ target: { checked } }) => {
                await onChange({
                  eventSummaryEmails: checked,
                });
              }}
            />
          </FormControl>
        </Stack>
         <Divider border="1px solid" borderColor="secondary.500" mt="0" />
        <Stack px="4" py="4">
          <FormControl
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            w="full"
            isDisabled={isDisabled}
          >
            <FormLabel mb="0" color="textPrimary.500" _disabled={{ color: "textPrimary.500", opacity: 1 }}>Sponsored Event Emails</FormLabel>
            <Switch
              isChecked={
                user.sponsoredEventEmails === null ||
                user.sponsoredEventEmails === undefined
                  ? true
                  : user.sponsoredEventEmails
              }
              onChange={async ({ target: { checked } }) => {
                await onChange({
                  sponsoredEventEmails: checked,
                });
              }}
            />
          </FormControl>
        </Stack>
      </Stack>
      </Stack>
    </Card>
  );
};
EventNotifications.userFragment = gql`
  fragment EventNotifications_User on User {
    _id
    eventConfirmationEmails
    eventReminderEmails
    eventSummaryEmails
    sponsoredEventEmails
  }
`;
